import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from 'styled-components';
import { getCanonicalURL } from './utils';
export var Head = function Head(_ref) {
  var title = _ref.title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$canonical = _ref.canonical,
    canonical = _ref$canonical === void 0 ? null : _ref$canonical,
    _ref$withoutName = _ref.withoutName,
    withoutName = _ref$withoutName === void 0 ? false : _ref$withoutName,
    _ref$next = _ref.next,
    next = _ref$next === void 0 ? null : _ref$next,
    _ref$prev = _ref.prev,
    prev = _ref$prev === void 0 ? null : _ref$prev,
    _ref$robots = _ref.robots,
    robots = _ref$robots === void 0 ? null : _ref$robots,
    _ref$schemaORG = _ref.schemaORG,
    schemaORG = _ref$schemaORG === void 0 ? null : _ref$schemaORG,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$twitter = _ref.twitter,
    twitter = _ref$twitter === void 0 ? null : _ref$twitter,
    _ref$openGraph = _ref.openGraph,
    openGraph = _ref$openGraph === void 0 ? null : _ref$openGraph;
  var canonicalURL = getCanonicalURL(canonical);
  var nextURL = getCanonicalURL(next);
  var prevURL = getCanonicalURL(prev);
  var theme = useTheme();
  var partner = theme.partner || {
    name: 'Finect'
  };
  var name = partner.name;
  var displayTitle = title ? withoutName ? title : "".concat(title, " - ").concat(name) : name;
  return React.createElement(Helmet, null, React.createElement("title", null, displayTitle), description ? React.createElement("meta", {
    name: "description",
    content: description
  }) : null, canonicalURL ? React.createElement("link", {
    rel: "canonical",
    href: canonicalURL
  }) : null, prevURL ? React.createElement("link", {
    rel: "prev",
    href: prevURL
  }) : null, nextURL ? React.createElement("link", {
    rel: "next",
    href: nextURL
  }) : null, schemaORG ? React.createElement("script", {
    type: "application/ld+json"
  }, schemaORG) : null, robots ? React.createElement("meta", {
    name: "robots",
    content: robots
  }) : null, twitter ? React.createElement("meta", {
    name: "twitter:site",
    content: twitter.site || '@finect'
  }) : null, twitter ? React.createElement("meta", {
    name: "twitter:card",
    content: twitter.card || 'summary_large_image'
  }) : null, twitter ? React.createElement("meta", {
    name: "twitter:title",
    content: twitter.title || ''
  }) : null, twitter ? React.createElement("meta", {
    name: "twitter:description",
    content: twitter.description || ''
  }) : null, twitter ? React.createElement("meta", {
    name: "twitter:image",
    content: twitter.image
  }) : null, openGraph ? React.createElement("meta", {
    property: "og:site_name",
    content: openGraph.site || 'Finect'
  }) : null, openGraph ? React.createElement("meta", {
    property: "og:image",
    content: openGraph.image
  }) : null, openGraph ? React.createElement("meta", {
    property: "og:title",
    content: openGraph.title
  }) : null, openGraph ? React.createElement("meta", {
    property: "og:description",
    content: openGraph.description
  }) : null, children || null);
};